<app-step description="Wybierz uszkodzony element"
          [nextVisible]="false"
          (previousStepClicked)="this.navigation.back()">

  <shared-lokalizacje-uszkodzen
    [idPrzedmiotu]=this.idPrzedmiotu
    [typPrzedmiotu]=this.typPrzedmiotu
    [lokalizacjeUszkodzen]="pobierzLokalizacjePomieszczen()"
  ></shared-lokalizacje-uszkodzen>
</app-step>
